import React, {useCallback, useState} from "react";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  InputGroup,
  Row,
  Input
  // @ts-ignore
} from "reactstrap";
import {Formik, Form, Field} from "formik";
import "./login.scss";
import AlertMessage from "../AlertMessage/AlertMessage";

import * as yup from 'yup';
import * as apiCalls from '../../ApiCalls';
import {useHistory} from "react-router-dom";


function PortalPasswordReset() {
  const history = useHistory();

  const [alerts, setAlerts] = useState<{ type: string, msg: string }>();

  const resetSchema = yup.object({
    email: yup.string().trim().email().required("Email required")
  })

  const requestPassword = useCallback((values: { email: string }) => {
    apiCalls.newPasswordRequest(values.email)
      .then((response) => {
        if (response) {
          setAlerts({ type: 'success', msg: 'If the email is attached to an account, an email containing a temporary password has been sent' })
        } else {
          setAlerts({ type: 'danger', msg: 'Unknown Error' })
        }
      })
  }, []);

  function handleLogin() {
    history.push('/login');
  }

  return (
    <div>
      {alerts && <AlertMessage {...alerts} />}
      <Formik initialValues={{ email: '' }} validationSchema={resetSchema} onSubmit={requestPassword}>
        <div className={'app flex-row align-items-center'}>
          <Container>
            <Row className={'justify-content-center'}>
              <Col md={8}>
                <CardGroup>
                  <Card className={'p-4'}>
                    <CardBody>
                      <Form>
                        <Row style={{ marginBottom: '2%' }} />
                        <Field name={'email'} component={({ field, form }: any) => (
                          <InputGroup className={'mb-3'}>
                            <Input type={'email'} {...field} placeholder={'Email'}
                                   invalid={form.errors.email && form.touched.email} />
                          </InputGroup>
                        )} />
                        <Row>
                          <Col xs={'auto'}>
                            <Button color={'secondary'} className={'px-4'} onClick={handleLogin}>
                              Cancel
                            </Button>
                          </Col>
                          <Col />
                          <Col xs={'auto'}>
                            <Button type={'submit'} color={'primary'} className={'px-4'}>
                              Submit
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </Formik>
    </div>
  )
}

export default PortalPasswordReset;
